module.exports = __webpack_public_path__ + "static/img/footLogo.c8901548.png";